/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CurrencyModel } from '../models/currency-model';
import { deleteApiCurrencyV1Id } from '../fn/currency/delete-api-currency-v-1-id';
import { DeleteApiCurrencyV1Id$Params } from '../fn/currency/delete-api-currency-v-1-id';
import { getApiCurrencyV1$Json } from '../fn/currency/get-api-currency-v-1-json';
import { GetApiCurrencyV1$Json$Params } from '../fn/currency/get-api-currency-v-1-json';
import { getApiCurrencyV1$Plain } from '../fn/currency/get-api-currency-v-1-plain';
import { GetApiCurrencyV1$Plain$Params } from '../fn/currency/get-api-currency-v-1-plain';
import { getApiCurrencyV1Id$Json } from '../fn/currency/get-api-currency-v-1-id-json';
import { GetApiCurrencyV1Id$Json$Params } from '../fn/currency/get-api-currency-v-1-id-json';
import { getApiCurrencyV1Id$Plain } from '../fn/currency/get-api-currency-v-1-id-plain';
import { GetApiCurrencyV1Id$Plain$Params } from '../fn/currency/get-api-currency-v-1-id-plain';
import { postApiCurrencyV1$Json } from '../fn/currency/post-api-currency-v-1-json';
import { PostApiCurrencyV1$Json$Params } from '../fn/currency/post-api-currency-v-1-json';
import { postApiCurrencyV1$Plain } from '../fn/currency/post-api-currency-v-1-plain';
import { PostApiCurrencyV1$Plain$Params } from '../fn/currency/post-api-currency-v-1-plain';
import { postApiCurrencyV1Create$Json } from '../fn/currency/post-api-currency-v-1-create-json';
import { PostApiCurrencyV1Create$Json$Params } from '../fn/currency/post-api-currency-v-1-create-json';
import { postApiCurrencyV1Create$Plain } from '../fn/currency/post-api-currency-v-1-create-plain';
import { PostApiCurrencyV1Create$Plain$Params } from '../fn/currency/post-api-currency-v-1-create-plain';
import { putApiCurrencyV1Id$Json } from '../fn/currency/put-api-currency-v-1-id-json';
import { PutApiCurrencyV1Id$Json$Params } from '../fn/currency/put-api-currency-v-1-id-json';
import { putApiCurrencyV1Id$Plain } from '../fn/currency/put-api-currency-v-1-id-plain';
import { PutApiCurrencyV1Id$Plain$Params } from '../fn/currency/put-api-currency-v-1-id-plain';

@Injectable({ providedIn: 'root' })
export class CurrencyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getApiCurrencyV1()` */
  static readonly GetApiCurrencyV1Path = '/private/v1/currencies';

  /**
   * Retrieve the list all the existing Currencies from the database asynchronously (parameter).
   *
   * Retrieve the list all the existing Currencies from the database asynchronously (parameter).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiCurrencyV1$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiCurrencyV1$Plain$Response(params?: GetApiCurrencyV1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CurrencyModel>>> {
    return getApiCurrencyV1$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve the list all the existing Currencies from the database asynchronously (parameter).
   *
   * Retrieve the list all the existing Currencies from the database asynchronously (parameter).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiCurrencyV1$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiCurrencyV1$Plain(params?: GetApiCurrencyV1$Plain$Params, context?: HttpContext): Observable<Array<CurrencyModel>> {
    return this.getApiCurrencyV1$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CurrencyModel>>): Array<CurrencyModel> => r.body)
    );
  }

  /**
   * Retrieve the list all the existing Currencies from the database asynchronously (parameter).
   *
   * Retrieve the list all the existing Currencies from the database asynchronously (parameter).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiCurrencyV1$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiCurrencyV1$Json$Response(params?: GetApiCurrencyV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CurrencyModel>>> {
    return getApiCurrencyV1$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve the list all the existing Currencies from the database asynchronously (parameter).
   *
   * Retrieve the list all the existing Currencies from the database asynchronously (parameter).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiCurrencyV1$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiCurrencyV1$Json(params?: GetApiCurrencyV1$Json$Params, context?: HttpContext): Observable<Array<CurrencyModel>> {
    return this.getApiCurrencyV1$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CurrencyModel>>): Array<CurrencyModel> => r.body)
    );
  }

  /** Path part for operation `postApiCurrencyV1()` */
  static readonly PostApiCurrencyV1Path = '/private/v1/currencies';

  /**
   * Retrieve the list all of the existing currencies from the database asynchronously.
   *
   * Retrieve the list all of the existing currencies from the database asynchronously
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCurrencyV1$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCurrencyV1$Plain$Response(params?: PostApiCurrencyV1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CurrencyModel>>> {
    return postApiCurrencyV1$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve the list all of the existing currencies from the database asynchronously.
   *
   * Retrieve the list all of the existing currencies from the database asynchronously
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCurrencyV1$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCurrencyV1$Plain(params?: PostApiCurrencyV1$Plain$Params, context?: HttpContext): Observable<Array<CurrencyModel>> {
    return this.postApiCurrencyV1$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CurrencyModel>>): Array<CurrencyModel> => r.body)
    );
  }

  /**
   * Retrieve the list all of the existing currencies from the database asynchronously.
   *
   * Retrieve the list all of the existing currencies from the database asynchronously
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCurrencyV1$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCurrencyV1$Json$Response(params?: PostApiCurrencyV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CurrencyModel>>> {
    return postApiCurrencyV1$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve the list all of the existing currencies from the database asynchronously.
   *
   * Retrieve the list all of the existing currencies from the database asynchronously
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCurrencyV1$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCurrencyV1$Json(params?: PostApiCurrencyV1$Json$Params, context?: HttpContext): Observable<Array<CurrencyModel>> {
    return this.postApiCurrencyV1$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CurrencyModel>>): Array<CurrencyModel> => r.body)
    );
  }

  /** Path part for operation `getApiCurrencyV1Id()` */
  static readonly GetApiCurrencyV1IdPath = '/private/v1/currencies/{id}';

  /**
   * Retrieves a Language by ID.
   *
   * Retrieves a Language by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiCurrencyV1Id$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiCurrencyV1Id$Plain$Response(params: GetApiCurrencyV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CurrencyModel>>> {
    return getApiCurrencyV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a Language by ID.
   *
   * Retrieves a Language by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiCurrencyV1Id$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiCurrencyV1Id$Plain(params: GetApiCurrencyV1Id$Plain$Params, context?: HttpContext): Observable<Array<CurrencyModel>> {
    return this.getApiCurrencyV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CurrencyModel>>): Array<CurrencyModel> => r.body)
    );
  }

  /**
   * Retrieves a Language by ID.
   *
   * Retrieves a Language by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiCurrencyV1Id$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiCurrencyV1Id$Json$Response(params: GetApiCurrencyV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CurrencyModel>>> {
    return getApiCurrencyV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a Language by ID.
   *
   * Retrieves a Language by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiCurrencyV1Id$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiCurrencyV1Id$Json(params: GetApiCurrencyV1Id$Json$Params, context?: HttpContext): Observable<Array<CurrencyModel>> {
    return this.getApiCurrencyV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CurrencyModel>>): Array<CurrencyModel> => r.body)
    );
  }

  /** Path part for operation `putApiCurrencyV1Id()` */
  static readonly PutApiCurrencyV1IdPath = '/private/v1/currencies/{id}';

  /**
   * Updates an existing currency Name by ID.
   *
   * Updates an existing currency Name by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiCurrencyV1Id$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiCurrencyV1Id$Plain$Response(params: PutApiCurrencyV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CurrencyModel>>> {
    return putApiCurrencyV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing currency Name by ID.
   *
   * Updates an existing currency Name by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiCurrencyV1Id$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiCurrencyV1Id$Plain(params: PutApiCurrencyV1Id$Plain$Params, context?: HttpContext): Observable<Array<CurrencyModel>> {
    return this.putApiCurrencyV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CurrencyModel>>): Array<CurrencyModel> => r.body)
    );
  }

  /**
   * Updates an existing currency Name by ID.
   *
   * Updates an existing currency Name by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiCurrencyV1Id$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiCurrencyV1Id$Json$Response(params: PutApiCurrencyV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CurrencyModel>>> {
    return putApiCurrencyV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing currency Name by ID.
   *
   * Updates an existing currency Name by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiCurrencyV1Id$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiCurrencyV1Id$Json(params: PutApiCurrencyV1Id$Json$Params, context?: HttpContext): Observable<Array<CurrencyModel>> {
    return this.putApiCurrencyV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CurrencyModel>>): Array<CurrencyModel> => r.body)
    );
  }

  /** Path part for operation `deleteApiCurrencyV1Id()` */
  static readonly DeleteApiCurrencyV1IdPath = '/private/v1/currencies/{id}';

  /**
   * Deletes a Currency by ID.
   *
   * Deletes a Currency by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteApiCurrencyV1Id()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiCurrencyV1Id$Response(params: DeleteApiCurrencyV1Id$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteApiCurrencyV1Id(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a Currency by ID.
   *
   * Deletes a Currency by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteApiCurrencyV1Id$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiCurrencyV1Id(params: DeleteApiCurrencyV1Id$Params, context?: HttpContext): Observable<void> {
    return this.deleteApiCurrencyV1Id$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postApiCurrencyV1Create()` */
  static readonly PostApiCurrencyV1CreatePath = '/private/v1/currencies/Create';

  /**
   * Creates a new currency.
   *
   * Creates a new currency.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCurrencyV1Create$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCurrencyV1Create$Plain$Response(params?: PostApiCurrencyV1Create$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CurrencyModel>> {
    return postApiCurrencyV1Create$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new currency.
   *
   * Creates a new currency.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCurrencyV1Create$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCurrencyV1Create$Plain(params?: PostApiCurrencyV1Create$Plain$Params, context?: HttpContext): Observable<CurrencyModel> {
    return this.postApiCurrencyV1Create$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CurrencyModel>): CurrencyModel => r.body)
    );
  }

  /**
   * Creates a new currency.
   *
   * Creates a new currency.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCurrencyV1Create$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCurrencyV1Create$Json$Response(params?: PostApiCurrencyV1Create$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CurrencyModel>> {
    return postApiCurrencyV1Create$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new currency.
   *
   * Creates a new currency.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCurrencyV1Create$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCurrencyV1Create$Json(params?: PostApiCurrencyV1Create$Json$Params, context?: HttpContext): Observable<CurrencyModel> {
    return this.postApiCurrencyV1Create$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CurrencyModel>): CurrencyModel => r.body)
    );
  }

}
